<app-sidebar *ngIf="login_status"></app-sidebar>
<app-header *ngIf="login_status && router.url != '/login'"></app-header>
<div [ngClass]="{'lg:ml-64': side_bartoggle, 'lg:ml-0': !side_bartoggle}" >
    <router-outlet></router-outlet>
</div>
